import { render, staticRenderFns } from "./GeonotesSettings.vue?vue&type=template&id=5f414aa1&"
import script from "./GeonotesSettings.vue?vue&type=script&lang=js&"
export * from "./GeonotesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports